import { useEffect, useMemo } from 'react';

export default function useBlobURL(blob: Blob) {
  const blobURL = useMemo(() => URL.createObjectURL(blob), [blob]);

  useEffect(() => () => URL.revokeObjectURL(blobURL), [blobURL]);

  return blobURL;
}
